<mat-accordion multi="true" displayMode="flat">
  @for (card of cards(); track card) {
    <ng-container *ngComponentOutlet="card.component; inputs: cardData()"></ng-container>
  }
</mat-accordion>
